<template>
    <div class="body" :style="{background: backgroundUrl ,overflowX: 'hidden'}">
        <div class="blur">

        </div>
        <div
            class="containerBody"
            :style="{
                background: backgroundUrl,
                height: 'auto',
                width: '100%',
                zIndex : 2,
                position : 'relative'
            }"
        >
            <div class="headItem">
                <div class="flex1"></div>
                <img v-if="eventsImage.LogoImg != ''" :src="eventsImage.LogoImg" class="logoImg"  alt="" >
                <img
                    v-else
                    src="../assets/defult/img/defultLOGO1.png"
                    class="logoImg"
                    alt=""
                />
                <div class="headBtn">
                    <div class="ui-gotop">
                        <img
                            src="../assets/defult/img/directions.png"
                            @click="showIntroduction = !showIntroduction"
                        />
                    </div>
                    <div class="ui-gotop2">
                        <a :href="backUrl">
                            <img src="../assets/defult/img/Home.png" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="titleImgContain">
                <img
                    v-if="eventsImage.TitleImg != ''"
                    :src="eventsImage.TitleImg"
                    alt=""
                    class="titleImg"
                />
                <img
                    v-else
                    src="../assets/defult/img/defultTitle.png"
                    alt=""
                    class="titleImg"
                />
            </div>
            <div style="text-align: center" class="time_to">
                <span :style="{color: timeColorCode == '' ? '#000' : timeColorCode}">{{ $t("turn.EventsTime") }}</span>
                <div class="time_to_container">
                    <div style="padding: 4px">
                        <span class="textTime" :style="{color: colorCode == '' ? '#000' : colorCode}">{{ startTime[0] }}</span>
                        <br />
                        <span class="textTime1" :style="{color: timeColorCode == '' ? '#000' : timeColorCode}">{{ startTime[1] }}</span>
                    </div>
                    <div class="to01" :style="{ background: timeColorCode == '' ? '#000' : timeColorCode }">
                    </div>
                    <div style="padding: 4px">
                        <span class="textTime" :style="{color: colorCode == '' ? '#000' : colorCode}"> {{ endTime[0] }}</span>
                        <br />
                        <span class="textTime1" :style="{color: timeColorCode == '' ? '#000' : timeColorCode}">{{ endTime[1] }}</span>
                    </div>
                </div>
                <div class="hr" :style="{borderColor: colorCode == '' ? '#000' : colorCode}"></div>
                <img
                    v-if="eventsImage.DirectionsImg != ''"
                    :src="eventsImage.DirectionsImg"
                    style="width: 100%"
                    alt=""
                />
                <img
                    v-else
                    :src="require('../assets/defult/img/defultDirect.png')"
                    style="width: 100%"
                    alt=""
                    width="100%"
                />
                <div class="hr" :style="{borderColor: colorCode == '' ? '#000' : colorCode}"></div>
            </div>
            <div>
                <div class="row align-items-md-stretch">
                    <div class="col-md-12">
                        <div class="row">
                            <div
                                class="container text-center"
                                :style="{color: colorCode == '' ? '#000' : colorCode}"
                            >
                                <div class="userInf">
                                    <div class="userInfBorder" :style="{ borderStyle: 'solid' }">
                                        <div class="col-md-6 col-6">
                                            <span class="mt-2"
                                                >{{ $t("turn.account") }}：
                                                <span>{{
                                                    this.user
                                                }}</span>
                                            </span>
                                        </div>
                                        <div class="col-md-4 col-4">
                                            <span class="mt-2"
                                                >{{ $t("turn.count") }}：
                                                <span>{{ this.count }}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-2 recordContainer">
                                        <img v-if="eventsImage.WinningIcon != ''" :src="eventsImage.WinningIcon" class="recordImg" style="cursor: pointer;" @click="showWinningRecordTable =!showWinningRecordTable">
                                        <img
                                            v-else
                                            src="../assets/defult/img/record1.png"
                                            style="cursor: pointer"
                                            class="recordImg"
                                            @click="
                                                showWinningRecordTable =
                                                    !showWinningRecordTable
                                            "
                                        />
                                        <div
                                            class="recordShow"
                                            v-if="showWinningRecordTable"
                                        >
                                            <table class="recordShowTable" :style="{color: colorCode == '' ? '#000' : colorCode}">
                                                <tr class="thead" :style="{borderColor: colorCode == '' ? '#000' : colorCode , background : colorCode == '' ? '#000' : colorCode }">
                                                    <th :style="{borderColor: colorCode == '' ? '#000' : colorCode}">{{ $t('winningRecord.winningTime') }}</th>
                                                    <th :style="{borderColor: colorCode == '' ? '#000' : colorCode}">{{ $t('winningRecord.award') }}</th>
                                                    <!-- <th>{{ $t('winningRecord.status') }}</th> -->
                                                </tr>
                                                <tr
                                                    v-for="data in winningData"
                                                    :key="data.id"
                                                    :style="{borderColor: colorCode == '' ? '#000' : colorCode}"
                                                >
                                                    <th scope="row" :style="{borderColor: colorCode == '' ? '#000' : colorCode}">
                                                        {{ data.drawTime }}
                                                    </th>
                                                    <td :style="{borderColor: colorCode == '' ? '#000' : colorCode}">{{ data.award }}</td>
                                                    <!-- <td
                                                        :style="
                                                            activation(
                                                                data.status
                                                            )
                                                        "
                                                    >
                                                        {{ data.status }}
                                                    </td> -->
                                                </tr>
                                                <tfoot :style="{borderColor: colorCode == '' ? '#000' : colorCode}">
                                                  <tr :style="{borderColor: colorCode == '' ? '#000' : colorCode}">
                                                    <th colspan ="2" :style="{borderColor: colorCode == '' ? '#000' : colorCode}">
                                                      <el-button type="info" plain size="small" v-if="currentPage > 1"
                                                        @click="nextPage(-1)">{{ $t('winningRecord.previousPage') }}</el-button>
                                                      <span :style="{color: colorCode == '' ? '#000' : colorCode}">{{ $t('winningRecord.page', { page: currentPage }) }}</span>
                                                      <el-button type="info" plain size="small" v-if="nextPageVisable"
                                                        @click="nextPage(1)">{{ $t('winningRecord.nextPage') }}</el-button>
                                                    </th>
                                                  </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="" class="hitEgg" @click="openHitEgg">
                      <img v-if="eventsImage.StartImg != ''" :src="eventsImage.StartImg"  style="cursor: pointer;" >
                      <img v-else src="../assets/defult/img/lottery.png" style="cursor: pointer;"/>

                    </div>
                    <div>
                        <div v-show="isAwards">
                            <div class="swiper-container swiperContainer">
                                <div class="swiper-wrapper">
                                    <div
                                        class="swiper-slide"
                                        style=" display: flex; align-items: center;  "
                                        v-for="(item, index) in awardsListIndex"
                                        :key="index"
                                    >
                                        <img v-if="item!=''"
                                            class="eventsAwards"
                                            :src="item"
                                            style="width: 100%"
                                            alt
                                        />
                                          <img v-else
                                              class="eventsAwards"
                                              src="../assets/defult/img/Prize.png"
                                              style="width: 100%"
                                              alt
                                          />
                                    </div>
                                </div>
                                <div class="swiper-button-prev"></div>
                                <div class="swiper-button-next"></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="footerContainer" style="">
                            <div class="footContent">
                                <img
                                    v-for="logo in footerlogo"
                                    v-bind:key="logo"
                                    :src="'./file/image/' +  platform + '/' +  logo +  '.png'  "
                                    class="footerLogoItem"
                                    width="100%"
                                />
                            </div>
                        </div>
                    </div>
                    <lotteryDesc
                        :introduction="introduction"
                        :showIntroduction="showIntroduction"
                        @closeModal="closeModal"
                    />
                    <div class="hit_egg_fixed_container" v-show="showBreakEggDialog">
                        <!-- <lotteryHitEgg @closeDialog="showBreakEggDialog = false" /> -->
                        <component ref="eventPlate" 
                            @closeDialog="showBreakEggDialog = false" 
                            :showGashaDialog="showBreakEggDialog"
                            :is="eventsName" 
                            :templateImage="templateImage" 
                            :templateSetting="templateSetting" 
                            :memberCount="count" 
                            :userData="userInformationData" 
                            :loading="loading" :awardsList="awardsListForm" 
                            @rollDone="rduceCount" 
                            :lang="lang" 
                            :propsMsg="msg" 
                            :propsMsg2="msg2" 
                            :code="code">
                        </component >

                    </div>
              <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true" :class="{ show, 'd-block': active }">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header"> -->
                      <!-- <h1 class="modal-title fs-5" id="exampleModalLabel">恭喜您中獎!</h1> -->

                      <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                    <!-- </div>
                    <div class="modal-body">
                      <p style="font-size: 2rem; font-weight: bold; text-align:center; margin-bottom: 1rem; color: #c29a2b;">
                        {{ msg }}</p>
                      <p style="font-size: 2rem; font-weight: bold; text-align:center; margin-bottom: 1rem; color: #c29a2b;">
                        {{ msg2 }}</p>
                      <button style="text-align:center;" type="button" class="btn btn-primary" data-dismiss="modal"
                        aria-label="Close" @click="active = false">{{ $t('button.confirm') }}</button>
                    </div>
                    <div class="modal-footer">
                    </div>
                  </div>
                </div>
              </div> -->
                    <!-- <div class="col-md-12"> -->
            <!-- <div class="lucky_bag">
              <component ref="eventPlate" @closeDialog="showBreakEggDialog = false" :is="'hongbao_modal'" :memberCount="count" :userData="userInformationData" :loading="loading" :awardsList="awardsListForm" @rollDone="rduceCount"></component >

              <img v-if="eventsImage.StartImg != ''" :src="eventsImage.StartImg" style="width: 100%;" alt="" @click="onCheck">
              <img v-else :src="require('../assets/defult/img/defultPrize.png')" alt="" style="width: 100%;" @click="onCheck">
            </div> -->
              <!-- <div class="modal fade" id="introductionModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2"
                tabindex="-1">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                    </div>
                    <div class="modal-body" style="background: rgba(6, 27, 14, 0.8);">
                      <div class="money_cover">

                        <div>
                          <div v-html="introduction"></div>
                        </div>
                      </div>
                      <img :src="require('../assets/hongbao/img/comfirm' + lang + '.png')" alt="" width="100%"
                        class="comfirm_btn" @click="closeMessage">
                    </div>
                  </div>
                </div>
              </div> -->
            <!-- <div class="modal fade" id="winningRecordModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <table class="table table-bordered text-center"
                    style="border-radius: 20px;max-width:1000px;margin: 0 auto;line-height: 1.5;background: linear-gradient(to bottom, #FFF4C8,#FCDE7C,#FFFAEE, #FFE979,#603515,#9F6F1D,#DCC35E); border: 5px solid #322fd000;">
                    <thead class="striped-tit">
                      <tr class="text-white" style="font-weight: bold;">
                        <th scope="col">{{ $t('winningRecord.winningTime') }}</th>
                        <th scope="col">{{ $t('winningRecord.award') }}</th>
                        <th scope="col">{{ $t('winningRecord.status') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="striped-1" v-for="data in winningData" :key="data.id">
                        <th scope="row">{{ data.drawTime }}</th>
                        <td>{{ data.award }}</td>
                        <td :style="activation(data.status)">{{ data.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style="text-align: center;">
                    <button type="button" class="btn btn-secondary" style="color: #fff;" v-if="currentPage > 1"
                      @click="nextPage(-1)">{{ $t('winningRecord.previousPage') }}</button>
                    <span style="color: #fff;">{{ $t('winningRecord.page', { page: currentPage }) }}</span>
                    <button type="button" class="btn btn-secondary" style="color: #fff;" v-if="nextPageVisable"
                      @click="nextPage(1)">{{ $t('winningRecord.nextPage') }}</button>
                  </div>
                </div>
              </div>
            </div> -->
          <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Loading } from "element-ui";
import hongbao_modal from "./hongbao_modal1.vue";
import turntable_modal from "./turntable_modal1.vue";
import eggs_modal from "./eggs_modal.vue";
import gasha_modal from "./gasha_modal.vue";
import bg from "../assets/defult/img/defultBG1.png";
import "../assets/defult/css/style.css";
import Swiper, { Navigation } from "swiper/js/swiper.min.js";
import "swiper/css/swiper.min.css";
// import '../assets/TW/css/bootstrap.css';

import lotteryDesc from "./lottery_desc.vue";
export default {
    components: {
        hongbao_modal,
        turntable_modal,
        eggs_modal,
        gasha_modal,
        lotteryDesc
    },
    data() {
        return {
            userInformationData: {
                token: "",
                peid: "",
            },
            backUrl: "",
            startTime: [],
            endTime: [],
            eventsName: "hongbao_modal",
            eventsStime: "",
            eventsEtime: "",
            eventsImage: [],
            show: false,
            msg: "",
            msg2: "",
            active: false,
            eid: "",
            winningData: [],
            awardsListForm: [],
            awardsListIndex: [],
            count: null,
            user: "",
            nextPageVisable: false,
            currentPage: 1,
            total: 0,
            page_size: 10,
            unlock: true,
            introduction: "",
            lang: "zh-tw",
            rolling: false,
            footerlogo: [],
            loading: true,
            mySwiper: null,
            isAwards: false,
            showWinningRecordTable: false,
            showIntroduction: false,
            showBreakEggDialog : false,
            backgroundUrl: `url(${bg})`,
            code: "0",
            platform: "",
            colorCode : "", // 字體顏色1
            timeColorCode : "", // 字體顏色2
            templateSetting: "",
            templateImage: "",
        };
    },
    mounted() {
        this.getEventsTime(this.$route.query.peid);
        this.checkUserToken(
            this.$route.query.token,
            this.$route.query.peid
        );
        this.getAwardsList();
        this.getMemberReport();
    },
    computed: {
        activation() {
            return (istatus) => {
                if (istatus == this.$t("turn.payed")) {
                    return { color: "red" };
                }
            };
        },
    },
    updated() {
        if (this.mySwiper != null) {
            this.$nextTick(() => {
                this.mySwiper.update();
            });
        }
    },
    methods: {
        initSwiper() {
            if (this.mySwiper != null) {
                return;
            }
            this.$nextTick(() => {
                this.mySwiper = new Swiper(".swiper-container", {
                    slidesPerView: 3,
                    centerInsufficientSlides: false,
                    centeredSlidesBounds: false,
                    centeredSlides: false,
                    spaceBetween: 0,
                    loop: true,
                    zoom: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            });
        },
        closeModal() {
            this.showIntroduction = false;
        },
        getEventsTime(peid) {
            let postData = {
                PEid: peid,
            };
            fetch("/api/getEventsTime", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    this.colorCode = res.data.ColorCode;
                    this.timeColorCode = res.data.TimeColor;
                    this.lang = res.data.Lang;
                    this.$i18n.locale = this.lang;
                    this.backUrl = res.data.BackUrl;
                    this.introduction = res.data.Introduction;
                    this.platform = res.data.Name;
                    this.eid = res.data.Eid;
                    this.$set(this, "eventsName", res.data.Ename + "_modal");
                    this.$forceUpdate();
                    this.eventsStime = res.data.StartTime.substr(0, 19);
                    this.eventsEtime = res.data.EndTime.substr(0, 19);
                    if (res.data.Footerlogo != "") {
                      this.footerlogo = JSON.parse(res.data.Footerlogo);
                    }
                    let st = "";
                    let et = "";
                    this.startTime = res.data.StartTime.split(" ");
                    this.endTime = res.data.EndTime.split(" ");
                    if (this.lang == "zh-tw") {
                        st =
                            this.startTime[0].substring(0, 4) +
                            "/" +
                            this.startTime[0].substring(5, 7) +
                            "/" +
                            this.startTime[0].substring(8, 10);
                        et =
                            this.endTime[0].substring(0, 4) +
                            "/" +
                            this.endTime[0].substring(5, 7) +
                            "/" +
                            this.endTime[0].substring(8, 10);
                    } else {
                        let sdate = new Date(this.eventsStime);
                        let enSDate = sdate.toDateString();
                        let enStartDateArray = enSDate.split(" ");
                        st = `${enStartDateArray[1]} ${enStartDateArray[2]}, ${enStartDateArray[3]}`;
                        let edate = new Date(this.eventsEtime);
                        let enEDate = edate.toDateString();
                        let enEndDateArray = enEDate.split(" ");
                        et = `${enEndDateArray[1]} ${enEndDateArray[2]}, ${enEndDateArray[3]}`;
                    }
                    this.startTime[0] = st;
                    this.endTime[0] = et;
                    this.getEventsTemplate();
                });
            this.getPlatformEventsImageByid(postData);
        },
        getEventsTemplate() {
            let postData = {
                Platform: this.platform,
                Template: this.eid,
            };
            fetch("/api/getEventsTemplate", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.code == 200) {
                        this.templateSetting = res.data[0].Setting
                        this.templateImage = res.data[0].Image
                    }
                })
                .finally(() => {
                });
        },
        getPlatformEventsImageByid(postData) {
            fetch("/api/getPlatformEventsImageByid", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.code == 200) {
                        this.eventsImage = res.data[0];
                    }
                    if (this.eventsImage.BgImg != "") {
                        // this.backgroundUrl = 'center / contain no-repeat url(' + this.eventsImage.BgImg + ')'
                        this.backgroundUrl =
                            "url(" + this.eventsImage.BgImg + ")";
                    }
                });
        },
        getAwardsList() {
            // this.isAwards = true;
            // this.initSwiper();
            let postData = {
                PEid: this.userInformationData.peid,
            };

            fetch("/api/getEventsAwardsList", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    for (var i = 0; i < res.data.length; i++) {
                        this.awardsListForm[i] = res.data[i].prizeName;
                        if (res.data[i].prizeImage != "") {
                            this.awardsListIndex[i] = res.data[i].prizeImage;
                        }else{
                            this.awardsListIndex[i] = ""
                        }
                    }
                    if (this.awardsListIndex.length > 0) {
                        this.isAwards = true;
                        this.initSwiper();
                    } else {
                        this.isAwards = false;
                    }
                    this.loading = false;
                    this.getWinningRecord(1);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        rduceCount(num) {
            this.count = this.count - num;
            this.getWinningRecord(num);
        },
        checkUserToken(token, peid) {
            this.userInformationData.token = token;
            this.userInformationData.peid = peid;
        },
        async getWinningRecord(page) {
            let loadingInstance = Loading.service({
                background: "rgba(0, 0, 0, 0.6)",
            });
            this.dialogTableVisible = true;
            let postData = {
                Token: this.userInformationData.token,
                PEid: this.userInformationData.peid,
                pageNum: page - 1,
            };
            await fetch("/api/getEventsWinning", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.data.length > 0 && res.code == "0") {
                        for (let index = 0; index < res.data.length; index++) {
                            res.data[index].drawTime = this.formatDate(
                                res.data[index].drawTime
                            );
                            res.data[index].award =
                                this.awardsListForm[res.data[index].award];
                            if (res.data[index].status == "0") {
                                res.data[index].status = this.$t("turn.unpay");
                            } else {
                                res.data[index].status = this.$t("turn.payed");
                            }
                        }
                        this.total = res.total;
                        let total_count = this.total / (page * 10);
                        if (total_count > 1) {
                            this.nextPageVisable = true;
                        } else {
                            this.nextPageVisable = false;
                        }
                        this.winningData = res.data;
                    }
                    loadingInstance.close();
                });
        },
        nextPage(number) {
            this.currentPage = this.currentPage + number;
            this.getWinningRecord(this.currentPage);
        },
        async getMemberReport() {
            let loadingInstance = Loading.service({
                background: "rgba(0, 0, 0, 0.6)",
            });
            let postData = {
                Token: this.userInformationData.token,
                PEid: this.userInformationData.peid,
            };
            await fetch("/api/getUserInfo", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.code == "0") {
                        if (res.data) {
                            this.count = Math.floor(res.data.count);
                            this.user = res.data.user
                        }
                    } else if (res.code == "1") {
                        //活動未開始
                        this.show = true;
                        this.active = true;
                        let arr = res.msg.split(" ");
                        this.msg = res.data;
                        this.msg2 = this.$t("turn." + arr[0]);
                        this.unlock = false;
                        this.count = 0;
                    } else if (res.code == "2") {
                        //活動已結束
                        this.show = true;
                        this.active = true;
                        let arr = res.msg.split(" ");
                        this.msg = this.$t("turn." + arr[0]);
                        this.msg2 = this.$t("turn." + arr[1]);
                        this.unlock = false;
                        this.count = 0;
                    } else {
                        this.$message.error(
                            this.$t("turn." + res.data) +
                                this.$t("turn.contact")
                        );
                        this.msg = this.$t("turn." + res.data);
                        this.msg2 = this.$t("turn.contact");
                        this.unlock = false;
                        this.count = 0;
                    }
                    this.code = res.code
                    loadingInstance.close();
                });
        },
        openHitEgg() {
            this.showBreakEggDialog = true
            // this.$router.push(
            //     "/lottery_hit_egg?user=0906366463&p=1688&token=NjMwMzE0NDgtZWYwMS00M2YwLWI5YmMtNzhlMDQ1NDMwODY3&peid=1681107092"
            // );
        },
        formatDate(value) {
            value = parseInt(value) * 1000;
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            let h = date.getHours();
            h = h < 10 ? "0" + h : h;
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m;
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s;
            return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
        },
    },
};
</script>


<style scoped>
.blur {
    position: fixed;
    top:0;
    left:0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(10px);
    z-index: 1;
}
/* @import '../assets/hongbao/css/style.css';
@import '../assets/hongbao/css/animate.css';
@import '../assets/hongbao/css/bootstrap.css'; */
.swiper-slide-active {
    /* transform: scale(1.2); */
}


</style>



// WEBPACK FOOTER //
// src/components/lottery.vue